/**
 * Strip HTML tags and entities to get clean plain text.
 * Converts <br>, <p>, <div> to newlines, removes all other tags,
 * and decodes HTML entities like &nbsp;
 */
export const stripHTML = (html: string): string => {
  if (!html) return '';
  const temp = document.createElement('div');
  temp.innerHTML = html.replace(/&nbsp;/g, ' ').replace(/<br\s*\/?>/gi, '\n');
  return (temp.textContent || temp.innerText || '').replace(/\n{3,}/g, '\n\n').trim();
};
